import React, { useState, useEffect } from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { throttle } from "lodash";
import Labeler from "./component";
import Spinner from "../common/Spinner";
import { useHotkeys } from "../../tools/react-hotkeys-hook";
import withContext from "../../tools/withContext";
import LabelerSegmentationStore from "../../store/segmentation-store/labelerSegmentationStore";

const DEFAULT_DIMENSIONS = { height: 576, width: 720 };

const LabelerContainerSegmentation = (props: any) => {
  
  const {
    match: {
      params: { noBatch, noImage },
    },
    history,
    ctx: { appFetch },
    labelerSegmentationStore
  } = props;

  const {
    images,
    isLoading,
    fetchImages,
    fetchBatch,
    dimensions,
    labeledImages,
    setDimensions,
    motifs,
  } = labelerSegmentationStore as LabelerSegmentationStore

  const [keyEvent, setKeyEvent] = useState<any>(null);

  const hotkeyCallback = throttle((e: any) => {
    if (e.key === "Tab") {
      e.preventDefault();
    }
    if (e.key === "Enter") {
      e.stopPropagation();
    }
    const { key, type, shiftKey, altKey, ctrlKey } = e;
    setKeyEvent({ key, type, shiftKey, altKey, ctrlKey });
  }, 750);

  useHotkeys("*", hotkeyCallback);

  const clearKeypressedState = () => setKeyEvent(null);

  useEffect(() => {
    fetchImages(appFetch, noBatch);
    fetchBatch(appFetch, noBatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {

    if (images.length > 0) {
      const out = Number(noImage) >= images.length;
      if (out) {
        const lastLabeledImage = labeledImages.length < images.length ? labeledImages.length : 0
        history.push(`/labelerSegmentation/${noBatch}/${lastLabeledImage}`);
      }
    }

    // sur les anciens lots maxWidth et maxHeight ne sont pas renseignés
    // du coup on utilise l'ancienne méthode : on prend pour dimensions du canvas
    // les dimensions de la première image
    if (images.length > 0 && !dimensions.height) {
      const image = new Image();
      image.onload = (event: Event) => {
        const { height, width } = event.target as HTMLImageElement;
        setDimensions({ height, width });
      };
      image.onerror = () => {
        const fallback = new Image();
        fallback.onload = (event: Event) => {
          const { height, width } = event.target as HTMLImageElement;
          setDimensions({ height, width });
        };
        fallback.onerror = () => {
          setDimensions(DEFAULT_DIMENSIONS);
        };
        fallback.src = "/404.png";
      };
      image.src = images[0].url;
    }
  }, [images, dimensions]);

  return (
    <>
      {isLoading && <Spinner message="Chargement des images" />}
      {!isLoading &&
        images.length > 0 &&
        motifs.length > 0 &&
        dimensions.height > 0 && (
          <Labeler
            keyEvent={keyEvent}
            clearKeyevent={clearKeypressedState}
          />
        )}
    </>
  );
};

export default withContext(withRouter(
  inject("labelerSegmentationStore")(observer(LabelerContainerSegmentation))
));

